import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const TrackingListRelatedAds = ({ads, listType, onProductsReceived}) => {
  const {domain} = useSuiContext()
  const {track: analyticsTrack} = useAnalyticsTrack()

  useMount(() => {
    domain
      .get('get_advertisements_tracking_use_case')
      .execute({
        ads: ads.map(({id, title, make, model, location, pack}) => ({
          id,
          title,
          make,
          model,
          location,
          pack
        })),
        adsTypeName: 'ad_impression',
        listType
      })
      .then(({products}) => {
        analyticsTrack({
          event: 'Ad Impressions Collected',
          data: {
            products
          }
        })
        onProductsReceived?.({products})
      })
  })

  return <></>
}

TrackingListRelatedAds.displayName = 'TrackingListRelatedAds'
TrackingListRelatedAds.propTypes = {
  ads: PropTypes.array.isRequired,
  listType: PropTypes.string,
  onProductsReceived: PropTypes.func
}

export default TrackingListRelatedAds
